import sharingGoods from './view/sharingGoods.html'
import utils from 'utils'
class goodsInfoListCtrl {
    constructor($scope, logger, httpRequest, $state, sweetalert, $uibModal, initSortService, operationService) {
        $scope.isAdmin = JSON.parse(localStorage.user_info).user.userType === 0 ? true : false
        // 已选择的数据 eg:[id1, id2]
        $scope.selectedArr = []
        httpRequest.get_getLoginUserGoodsTypeList(0).then((res) => {
            $scope.goodsTypeList = res.data.value
        })
        httpRequest.get_dictByTypeArr(['status', 'is_privilege', 'tax_includ', 'levy_way', 'data_share']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
            if (fromState.url.indexOf('/carAdd') > -1 || fromState.url.indexOf('/carEdit') > -1) {
                $scope.typeChange(1)
            }
        })
        // 下拉组件配置
        // $scope.queryConfig = {
        //     queryName: 'typeName',
        //     queryKey: 'typeId',
        //     queryType: 'Flater',
        //     multiple: false,
        //     parentIdName: 'parentTypeId',
        //     parentId: 0,
        // }
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                orgId: JSON.parse(localStorage.user_info).user.currentOrgId,
                goodsInfo: '',
                taxRate: '',
                status: '',
                goodsTypeList: '',
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param = {
                orgId: JSON.parse(localStorage.user_info).user.currentOrgId,
                goodsInfo: '',
                taxRate: '',
                status: '',
                goodsTypeList: '',
            }
            // $scope.queryConfig.defaultSelect = []
        }
        // $scope.reset()
        $scope.addGoods = function addGoods() {
            $state.go('outputManage.ovat.goodsInfo.add')
        }
        $scope.managementClass = function managementClass(type) {
            $state.go('outputManage.ovat.goodsInfo.goodstype', {
                type
            })
        }
        // 表头排序
        $scope.orderMap = initSortService('goodsInfoParam')
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('goodsInfoParam', JSON.stringify($scope.queryParam))
            $scope.queryGoodsInfo()
        }
        $scope.active = ''
        if (operationService.hasPermit('goods_info')) {
            $scope.active = 0
        } else if (operationService.hasPermit('car_code')) $scope.active = 1
        $scope.typeChange = function (v) {
            console.log(v)
            // isSearch = true
            $scope.active = v
        }
        // let isSearch = false
        // $scope.$watch('queryParam', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('outputManage.ovat.goodsInfo') != -1) {
        //         isSearch && sessionStorage.setItem('goodsInfoParam', JSON.stringify({ param: $scope.queryParam, active: $scope.active }))
        //     }
        // })
        // let active = 0
        // if (!$uibModal.hasPermit('goods_info')) active = 1
        // $scope.active = sessionStorage.goodsInfoParam ? JSON.parse(sessionStorage.goodsInfoParam).active : active
        $scope.queryGoodsInfo = function () {
            $scope.queryParam = sessionStorage.goodsInfoParam ? JSON.parse(sessionStorage.goodsInfoParam) : $scope.queryParam
            const openLoading = $scope.queryParam.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            }) : null
            httpRequest.post_pageGoodsInfo($scope.queryParam).then((res) => {
                $scope.resData = res.data.value.list
                $scope.selectedArr = []
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
            }).finally(() => {
                window.layer.close(openLoading)
            })
        }
        $scope.searchlist2 = function searchlist2() {
            sessionStorage.setItem('goodsInfoParam', JSON.stringify($scope.queryParam))
            $scope.queryGoodsInfo()
        }
        $scope.pageChanged2 = function () { // 点击页码发起查询
            sessionStorage.setItem('goodsInfoParam', JSON.stringify({
                orderMap: $scope.queryParam.orderMap,
                pageNum: $scope.queryParam.pageNum,
                pageSize: $scope.queryParam.pageSize,
                param: sessionStorage.goodsInfoParam ? JSON.parse(sessionStorage.goodsInfoParam).param : {
                    orgId: JSON.parse(localStorage.user_info).user.currentOrgId,
                    goodsInfo: '',
                    taxRate: '',
                    status: '',
                    goodsTypeList: '',
                },
            }))
            $scope.queryGoodsInfo()
        }
        // 删除多个确认弹窗
        $scope.delGoods = function (id) {
            const selectedArr = id || id === 0 ? [id] : $scope.selectedArr
            if (selectedArr.length > 0) {
                const msg = selectedArr.length > 1 ? '确认删除这些商品信息?' : '确认删除此商品信息?'
                sweetalert.confirm('删除提醒', msg).then(() => {
                    httpRequest.post_delGoodsInfo(selectedArr).then((res) => {
                        $scope.queryGoodsInfo()
                    })
                }, () => {

                })
            } else {
                logger.logError('请先选择商品')
            }
        }

        // 导出
        $scope.exportExel = function () {
            // httpRequest.get_importToExcel({
            //     goodsInfo: $scope.queryParam.param.goodsInfo || '',
            //     orgId: $scope.queryParam.param.orgId,
            //     status: $scope.queryParam.param.status || '',
            //     taxInclud: $scope.queryParam.param.taxInclud || '',
            //     taxRate: $scope.queryParam.param.taxRate || '',
            //     typeId: $scope.queryParam.param.typeId || '',
            //     accessToken: localStorage.id_token || '',
            //     dataShare: $scope.queryParam.param.dataShare || ''
            // })
            const reqObj = $.extend({}, {
                goodsInfo: $scope.queryParam.param.goodsInfo || '',
                orgId: $scope.queryParam.param.orgId,
                status: $scope.queryParam.param.status || '',
                taxInclud: $scope.queryParam.param.taxInclud || '',
                taxRate: $scope.queryParam.param.taxRate || '',
                typeId: $scope.queryParam.param.typeId || '',
                accessToken: localStorage.id_token || '',
                dataShare: $scope.queryParam.param.dataShare || ''
            }, {
                selectedIdList: $scope.selectedArr
            })
            let _url = `${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/importToExcel?accessToken=${localStorage.getItem('id_token')}`
            for (let i in $scope.queryParam.orderMap) {
                reqObj.sortField = i + ':' + $scope.queryParam.orderMap[i]
            }
            utils.post_downLoad(reqObj, _url)
        }

        // 搜索区商品分类变化
        // $scope.typeSelectChange = function (v) {
        //     const orgSelectArr = v
        //     const orgSelectL = orgSelectArr.length
        //     if (orgSelectL > 0) {
        //         $scope.queryParam.param.typeId = orgSelectArr[0].typeId
        //     } else {
        //         $scope.queryParam.param.typeId = ''
        //     }
        // }
        $scope.tableDropdownConfig = [{
            label: '编辑',
            handler(item) {
                const {
                    goodsId
                } = item
                if (!goodsId || goodsId === 0) {
                    logger.logError('参数错误，请刷新重试')
                } else {
                    $state.go('outputManage.ovat.goodsInfo.edit', {
                        goodsId
                    })
                }
            },
            showWhile(item, hasPermit) {
                return hasPermit('edit_goodsInfo') && (item.dataShare != 1 || $scope.isAdmin)
            },
        }, {
            label: '删除',
            handler(item) {
                $scope.delGoods(item.goodsId)
            },
            showWhile(item, hasPermit) {
                return hasPermit('del_goodsInfo')
            },
        }, {
            label: '启用',
            handler(item) {
                $scope.modGoodsStatus(item.goodsId, item.status)
            },
            showWhile(item, hasPermit) {
                return hasPermit('edit_goodsInfo') && item.status === 0
            },
        }, {
            label: '禁用',
            handler(item) {
                $scope.modGoodsStatus(item.goodsId, item.status)
            },
            showWhile(item, hasPermit) {
                return hasPermit('edit_goodsInfo') && item.status === 1 && (item.dataShare != 1 || $scope.isAdmin)
            },
        }]

        // 导入
        // 导入配置
        $scope.importconfig = {
            code: 'GOODS_INFO',
            appName: host.etcloudOvat,
            isSplit: true,
            url: 'dlTaskService/import_GOODS_INFO',
            downloadAppName: host.etcloudOvat,
            validate: {
                pattern: '.xlsx,.xls,.txt',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB'
                    },
                    duration: {
                        min: '10s',
                        max: '5m'
                    },
                    accept: '.xlsx,.xls,.xml,.txt',
                },
            },
            callback() {
                // 回掉，可选
                $scope.queryGoodsInfo()
            },
        }
        // 禁用确认弹窗
        $scope.modGoodsStatus = function (goodsInfoId, status) {
            // 弹出确认框
            const msg = status === 1 ? '确定要禁用此商品吗？' : '确定要启用此商品吗？'
            const title = status === 1 ? '禁用提醒' : '启用提醒'
            sweetalert.confirm(title, msg).then(() => {
                httpRequest.post_modGoodsInfoStatus({
                    goodsInfoId,
                    status: (status + 1) % 2,
                }).then(() => {
                    $scope.queryGoodsInfo()
                })
            }, () => {

            })
        }

        // 返回数据
        $scope.resData = []
        // 税率数组
        httpRequest.get_queryGoodsTax({
            taxMergeCode: -1,
            invType: -1,
        }).then((res) => {
            $scope.taxRateList = res.data.value
        })

        // 加载获取数据
        $scope.queryGoodsInfo()
        $scope.shareGoods = function () {
            $uibModal.open({
                template: sharingGoods,
                openedClass: 'mod-modal mod-modal-hg',
                controller: 'sharingGoodsCtrl',
                animation: true,
                resolve: {
                    modalParams() {
                        return {
                            type: 0,
                            dictData: $scope.dictData
                        }
                    },
                },
            }).result.then(() => {
                $scope.queryGoodsInfo()
            })
        }
    }
}
goodsInfoListCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', 'sweetalert', '$uibModal', 'initSortService', 'operationService']
export default goodsInfoListCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/goodsInfoListCtrl.js